import React from "react";
import TextField from "./TextField";
import SelectField from "./SelectField";
import countryConfig from "../countryConfig";
import { COUNTRIES_REGION_DROPDOWN } from "../../../common";
import { Combobox, TextInput } from "@paypalcorp/pp-react";

const RegionField = ({
  useCombobox = false,
  useTextInput = false,
  labelText,
  name,
  inputClassName = "",
  labelClassName = "",
  countryCode,
  errors = "",
  value,
  onChange,
  onBlur = () => {},
  className = ""
}) => {
  const label = countryConfig[countryCode]
    ? countryConfig[countryCode].regionLabel
    : labelText;
  const options = countryConfig[countryCode]
    ? countryConfig[countryCode].regions
    : [];

  const convertKeyTextToLabelValue =(data) => {
    return data.map(({ key, text }) => ({
      label: text,
      value: key
    }));
  };

  const sharedProps = {
    name,
    onChange,
    onBlur,
    errorText: errors,
    value
  };
  
  const dropdownComponent = useCombobox ? (
    <Combobox
      {...sharedProps}
      label={label}
      options={convertKeyTextToLabelValue(options)}
      inputClassName={inputClassName}
      labelClassName={labelClassName}
      className={className}
    />
  ) : (
    <SelectField
      {...sharedProps}
      labelText={label}
      options={options}
    />
  );

  const textComponent = useTextInput ? (
    <TextInput
      {...sharedProps}
      label={label}
      labelClassName={labelClassName}
      inputClassName={inputClassName}
    />
  ) : (
    <TextField
      {...sharedProps}
      labelText={label}
    />
  );


  return (
    <>
      {COUNTRIES_REGION_DROPDOWN.includes(countryCode)
        ? dropdownComponent
        : textComponent
      }
    </>
  );
};

export default RegionField;
